// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2ZP63","empty":"ModalGraph_empty__FtxVp"};